import "@formatjs/intl-relativetimeformat/locale-data/de";
import "@formatjs/intl-relativetimeformat/locale-data/en";
import "@formatjs/intl-relativetimeformat/polyfill";
import { IntlProvider } from "react-intl";
import { useLang } from "./Metronici18n";
import { useEffect, useState } from "react";

const I18nProvider = ({ children }) => {
  const locale = useLang();
  const [messages, setMessages] = useState({});

  useEffect(() => {
    const loadLanguage = async () => {
      try {
        const module = await import(`./messages/language`);
        const languages = module.default;

        const tempObj = {};
        Object.keys(languages).forEach((key) => {
          tempObj[key] = languages[key][locale];
        });

        setMessages(tempObj);
      } catch (error) {
        console.error("Error loading language module:", error);
      }
    };

    loadLanguage();
  }, [locale]);

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
};

export { I18nProvider };
